import { BaseCard, LandscapeImageCard } from '@bnnvara/cards';
import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../../../helpers/resizeImageSource';

export const CategoryCard = ({ title, description, thumbnail }) => {
  const image = resizeImageSource(
    thumbnail ? thumbnail.url : '/static/fallbackImages/videofallback.jpg',
    450
  );

  if (description) {
    return (
      <LandscapeImageCard
        title={title}
        description={description}
        thumbnail={image}
      />
    );
  }

  return <BaseCard title={title} backgroundImage={image} />;
};

CategoryCard.defaultProps = {
  thumbnail: null,
  description: null,
};

CategoryCard.propTypes = {
  thumbnail: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default CategoryCard;
